<template><div class="unit-status"
    ref="top"
    @keydown.left="navleft"
    @keydown.right="navright"
    @keydown.home="navhome"
    @keydown.end="navend"
    @keydown.33="navpgup"
    @keydown.34="navpgdown"
    tabindex="0">
  <div>
    <div class="date-row">
      <date-select v-model="datetime" :max="now" />
      <div>{{ datetime.format('HH:mm:ss') }} ({{ datetime.format('Z') }})</div>
      <div>
        <input type="checkbox" id="showLatest" v-model="showLatest" />
        <label for="showLatest">Show Latest</label>
      </div>
      <loading v-if="fetchingTimestamps" />
    </div>
    <div class="slider" ref="slider">
      <div class="offset" ref="offset">
        <div class="track"><div>
          <div class="range" v-for="(r,i) in timestampRanges" :style="getRangeStyle(r)" :key="`range-${i}`" />
        </div></div>
        <div class="handle" ref="handle" :style="handleStyle"><span class="material-icons">drag_indicator</span></div>
      </div>
      <div class="event" :class="{down:mouseIsDown}"
        @dragstart="dragstart"
        @mousedown="mousedown"
        @mousemove="mousemove"
        @mouseup="mouseup"
        @mouseout="mouseout"
        @touchstart="touchstart"
        @touchend="touchend"
        @touchmove="touchmove"
        />
    </div>
  </div>
  <div class="status-split">
    <div class="status-text">
      <loading v-if="fetchingTimestamp" />
      <div class="width-fix">
        <span v-if="typeof(status) === 'string'" v-html="status" />
        <div v-else-if="status" class="selectable">
          <table v-if="status.additional_data && status.additional_data.length">
          <tr v-for="row in (status.additional_data || [])" :key="`additionalData-${row[0]}`">
            <th v-html="row[0]" />
            <td v-html="row[1] !== null ? row[1] : '-'" />
          </tr>
          </table>
          <div v-if="status.title" class="title">{{ status.title }}</div>
          <div v-if="status.content" class="content">{{ status.content }}</div>
          <span v-if="(!status.additional_data || !status.additional_data.length) && !status.title && !status.content">
            There is no data to show.
          </span>
        </div>
      </div>
    </div>
    <g-map
        v-if="id && status && typeof(status) !== 'string'"
        :unitId="id"
        :gps="status.gps || null"
        :speed="status.speed || null"
      />
  </div>
</div></template>
<script>
import moment from 'moment'
import api from '../api'
import DateSelect from './DateSelect'
import GMap from './GMap'
import Loading from './Loading'
function getPageLeft(el) {
  let x = 0
  while (el) {
    x += el.offsetLeft
    el = el.offsetParent
  }
  return x
}
export default {
  name: 'unit-status',
  components: { DateSelect, GMap, Loading },
  data() {
    return {
      interval: setInterval(() => { this.now = moment() }, 1000),
      now: moment(),
      datetime: moment().endOf('day'),
      timestamps: [],
      timestampIndex: null,
      timestampRanges: [],
      fetchingTimestamps: false,
      fetchingTimestamp: false,
      refetchTimestamp: null,
      status: 'Loading...',
      mouseIsDown: false,
      ratio: null,
      showLatest: true,
    }
  },
  mounted() {
    if (this.id) {
      this.fetchTimestamps()
    }
    if (this.interval === null) {
      this.interval = setInterval(() => { this.now = moment() }, 1000)
    }
    this.$refs.top.focus()
  },
  destroyed() {
    clearInterval(this.interval)
    this.interval = null 
  },
  computed: {
    id() { return this.$store.state.selectedUnit },
    unit() { return this.$store.state.units[this.id] },
    handleStyle() {
      if (this.mouseIsDown) {
        return { left: `${100*this.ratio}%` }
      } else {
        let day = this.datetime.clone().startOf('day'),
          total = day.clone().endOf('day').diff(day, 'seconds'),
          ratio = this.datetime.diff(day, 'seconds') / total
        return { left: `${100*ratio}%` }
      }
    },
  },
  watch: {
    id(nv,ov) {
      this.fetchTimestamps()
    },
    'unit.lastPacketTime': function(nv, ov) {
      if (!nv || nv.isSame(ov)) return
      if (this.showLatest && this.datetime.isSame(ov, 'day') && !this.datetime.isSame(nv, 'day')) {
        this.datetime = nv.clone()
      } else if (this.datetime.isSame(nv, 'day') || this.datetime.isSame(ov, 'day')) {
        this.fetchTimestamps()
      }
    },
    datetime(nv, ov) {
      if (nv.isSame(ov)) return
      if (this.timestampIndex !== null) {
        if (!moment.isMoment(nv)
            || this.timestampIndex >= this.timestamps.length
            || nv.unix() !== this.timestamps[this.timestampIndex]) {
          this.timestampIndex = null
        }
      }
      if (!nv.isSame(ov, 'day')) {
        this.fetchTimestamps()
        this.showLatest = this.unit && this.datetime.isSame(this.unit.lastPacketTime)
      } else {
        if (this.unit && nv.isSame(this.unit.lastPacketTime)) {
          this.showLatest = true
        } else if (!nv.isSame(this.now, 'day')) {
          this.showLatest = false
        } else if (this.timestamps.length) {
          this.showLatest = !nv.isBefore(moment.unix(this.timestamps[this.timestamps.length-1]))
        }
        this.fetchTimestamp()
      }
    },
    timestampRanges() {
      let ov = this.datetime
      this.datetime = this.getBestDatetimeInRange(this.datetime)
      if (this.datetime.isSame(ov))  
        this.fetchTimestamp()
    },
    showLatest(nv,ov) {
      if (nv && !ov) {
        this.datetime = this.getBestDatetimeInRange(this.unit.lastPacketTime)
      }
    },
  },
  methods: {
    getBestDatetimeInRange(dt) {
      const rr = this.timestampRanges
      if (!rr || !rr.length || !this.datetime.isSame(dt, 'day')) return dt
      for (let i=0; i<rr.length; i++) {
        if (!rr[i].start.isAfter(dt)) {
          // Range start is before or same as current datetime.
          if (!rr[i].end.isBefore(dt)) {
            return dt // Range contains current datetime. No change needed!
          }
          continue // range is before datetime. look at next range.
        } else {
          // Range start is after current datetime.
          if (i == 0) {
            // This is the first range of the day. Select this range's start datetime.
            return rr[i].start.clone()
          } else if (dt.diff(rr[i-1].end) < rr[i].start.diff(dt)) {
            // The previous range's end datetime is closer than this range's start datetime. Choose the prev. end.
            return rr[i-1].end.clone()
          } else {
            // This range's start datetime is closer than the previous range's end datetime. Choose this'n's start.
            return rr[i].start.clone()
          }
        }
      }
      // All of the day's ranges are before the current datetime. Choose the last range's end datetime.
      return rr[rr.length-1].end.clone()
    },
    getRangeStyle(r) {
      let day = r.start.clone().startOf('day'),
        total = day.clone().endOf('day').diff(day, 'seconds'),
        left = 100*r.start.diff(day, 'seconds')/total,
        width = 100*r.end.diff(r.start, 'seconds')/total
      return {
        left: `${left}%`,
        width: `${width}%`,
      }
    },
    async fetchTimestamps() {
      if (this.fetchingTimestamps) {
        this.fetchingTimestamps.cancel()
        this.fetchingTimestamps = false
      }
      let newDate = !this.timestamps.length || !this.datetime.isSame(moment.unix(this.timestamps[0]), 'day')
      if (newDate) {
        this.timestamps = []
        this.timestampRanges = []
        if (this.fetchingTimestamp && this.fetchingTimestamp.cancel) {
          this.fetchingTimestamp.cancel()
        }
        this.fetchingTimestamp = true
      }
      let ref = this.fetchingTimestamps = {
        uid: this.id,
        start: newDate
          ? this.datetime.clone().startOf('day')
          : moment.unix(this.timestamps[this.timestamps.length-1]),
        end: this.datetime.clone().endOf('day')
      }
      try {
        let rv = await api.unitHeartbeatTimestamps(ref)
        if (newDate) {
          this.timestamps = rv
        } else {
          this.timestamps.push(...rv)
        }
        this.buildRanges(rv)
      } catch(e) {
        this.fetchingTimestamp = false
        if (newDate) {
          this.status = 'Error loading the selected date.'
        }
        if (!(e instanceof api.Canceled))
          console.error(e)
      } finally {
        this.fetchingTimestamps = false
      }

    },
    buildRanges(newTimestamps) {
      if (!newTimestamps || !newTimestamps.length)
        return
      let range = this.timestampRanges.length ? this.timestampRanges[this.timestampRanges.length - 1] : null,
        ts, diff
      for (ts of newTimestamps) {
        ts = moment.unix(ts)
        diff = range ? ts.diff(range.end, 'seconds') : 3600 
        if (diff > 1800)
          this.timestampRanges.push(range = { start: ts, end: ts.clone() })
        else if (diff > 0)
          range.end = ts
        else if (diff !== 0)
          console.error('timestamps were not strictly non-decreasing')
      }
      if (this.showLatest)
        this.datetime = ts
    },
    async fetchTimestamp() {
      if (this.fetchingTimestamp && this.fetchingTimestamp !== true) {
        this.refetchTimestamp = true
        return
      }
      this.refetchTimestamp = false
      let ref = this.fetchingTimestamp = {
        uid: this.id,
        when: this.datetime,
        cutoff: this.datetime.clone().endOf('day'),
      }
      try {
        this.status = await api.unitStatus(ref)
      } catch(e) {
        this.status = 'Error loading status.'
        if (!(e instanceof api.Canceled))
          console.error(e)
      } finally {
        this.fetchingTimestamp = false
      }
      if (this.refetchTimestamp) {
        this.fetchTimestamp()
      }
    },
    dragstart(e) {
      e.preventDefault()
    },
    mousedown(e) {
      this.mouseIsDown = true
      this.sliderResponse(e.pageX)
    },
    mousemove(e) {
      this.sliderResponse(e.pageX)
    },
    mouseup(e) {
      this.mouseIsDown = false
      this.sliderResponse(e.pageX)
    },
    mouseout(e) {
      this.mouseIsDown = false
    },
    touchstart(e) {
      this.mouseIsDown = e.touches.length === 1
      this.sliderResponse(e.touches[0].pageX)
      e.preventDefault()
    },
    touchmove(e) {
      if (e.touches.length === 1)
        this.sliderResponse(e.touches[0].pageX)
    },
    touchend(e) {
      this.mouseIsDown = false
      if (e.changedTouches.length === 1)
        this.sliderResponse(e.changedTouches[0].pageX)
    },
    sliderResponse(pageX) {
      let x = pageX - getPageLeft(this.$refs.offset),
        ratio = x / this.$refs.offset.offsetWidth
      if (ratio < 0) ratio = 0
      else if (ratio > 1) ratio = 1
      if (this.mouseIsDown) {
        this.ratio = ratio
        //this.$refs.handle.style.left = `${100*ratio}%`
      } else if (this.ratio !== null) {
        this.ratio = null
        let day = this.datetime.clone().startOf('day'),
          total = day.clone().endOf('day').diff(day, 'seconds')
        this.datetime = this.getBestDatetimeInRange(day.clone().add(total * ratio, 'seconds'))
      }
    },
    findTimestampIndex() {
      let ts = this.datetime.unix()
      if (this.timestampIndex !== null
          && this.timestampIndex < this.timestamps.length
          && this.timestamps[this.timestampIndex] === ts) {
        return // no change needed
      }
      let l, r, i, v
      l = 0
      r = this.timestamps.length
      while (r > l) {
        i = Math.floor((l + r) / 2)
        v = this.timestamps[i]
        if (v < ts) l = i + 1
        else if (v > ts) r = i
        else { l = r = i; break }
      }
      this.timestampIndex = l
    },
    navleft() {
      this.findTimestampIndex()
      if (this.timestampIndex > 0) {
        this.timestampIndex--
        this.datetime = moment.unix(this.timestamps[this.timestampIndex])
      } else {
        this.datetime = this.datetime.clone().subtract(1, 'day').endOf('day')
      }
    },
    navright() {
      this.findTimestampIndex()
      if (this.timestampIndex < this.timestamps.length - 1) {
        this.timestampIndex++
        this.datetime = moment.unix(this.timestamps[this.timestampIndex])
      } else {
        let nextDay = this.datetime.clone().add(1, 'day').startOf('day')
        if (nextDay.isBefore(this.now)) {
          this.datetime = nextDay
        }
      }
    },
    navhome() {
      if (this.timestamps.length)
        this.datetime = moment.unix(this.timestamps[0])
    },
    navend() {
      if (this.timestamps.length)
        this.datetime = moment.unix(this.timestamps[this.timestamps.length-1])
    },
    navpgup() {
      this.findTimestampIndex()
      let dt = this.datetime.unix() - 3600 // one hour in the past
      for (;;) {
        this.timestampIndex--
        if (this.timestampIndex < 0) {
          this.datetime = this.datetime.clone().subtract(1, 'day').endOf('day')
          return
        } else if (this.timestamps[this.timestampIndex] <= dt) {
          this.datetime = moment.unix(this.timestamps[this.timestampIndex])
          return
        }
      }
    },
    navpgdown() {
      let dt = this.datetime.unix() + 3600 // one hour in the future
      while (this.timestampIndex < this.timestamps.length) {
        if (this.timestamps[this.timestampIndex] >= dt) {
          this.datetime = moment.unix(this.timestamps[this.timestampIndex])
          return
        }
        this.timestampIndex++
      }
      dt = this.datetime.clone().add(1, 'day').startOf('day')
      if (dt.isAfter(this.now))
        this.datetime = this.getBestDatetimeInRange(this.now.clone())
      else
        this.datetime = dt
    },
  },
}
</script>
<style lang="scss" scoped>

$sh: 20px;
$hw: 30px;
$br: 5px;
$m: 10px;
$vm: 5px;
$hhw: calc($hw / 2);
$unavail: #888;
$avail: #0c0;

.unit-status {
  outline: none;
  background: #ddd;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  > :first-child {
    background: #bbb;
    padding: 5px 10px;
    .date-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      > * { margin-right: 20px; }
    }
    .loading {
      width: 18px;
      height: 18px;
    }
    .slider {
      position: relative;
      height: $hw;
      .offset {
        position: absolute;
        height: $hw;
        left: $hhw;
        right: $hhw;
      }
      .event {
        position: absolute;
        left: -$m;
        right: -$m;
        top: -$vm;
        height: $hw+2*$vm;
        &.down {
          position: fixed;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          height: auto;
          z-index: 1000;
        }
      }
      .track {
        position: absolute;
        left: calc(-1 * $sh / 2) - 1px;
        right: calc(-1 * $sh / 2) - 1px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: $br;
        border: 1px solid #666;
        height: $sh;
        box-sizing: border-box;
        background: $unavail;
        overflow: hidden;
        box-shadow: 0px 0px 2px 4px rgba(255,255,255,.7);
        > * {
          position: absolute;
          height: $sh;
          left: calc($sh / 2);
          right: calc($sh / 2);
          .range {
            position: absolute;
            height: $sh;
            border-left: $hhw solid $avail;
            border-right: $hhw solid $avail;
            transform: translateX(-$hhw);
            background: $avail;
          }
        }
      }
      .handle {
        position: absolute;
        width: $hw;
        height: $hw;
        transform: translateX(-$hhw);
        background: #fff;
        border-radius: $br;
        border: 1px solid #666;
        box-sizing: border-box;
        box-shadow: 2px 2px 5px rgba(0,0,0,0.5);
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 18px;
          color: #444;
        }
      }
    }
  }
  > .status-split {
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    position: relative;

    .status-text {
      box-sizing: border-box;
      max-width: 100%;
      flex-shrink: 0;
      padding: 20px;
      overflow: auto;
      position: relative;
      .loading {
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100px;
        height: 100px;
      }
      .width-fix {
        display: inline-block;
      }
      table {
        text-align: left;
        border-collapse: collapse;
        th { padding-right: 10px; }
        th, td { line-height: 140%; }
        margin-bottom: 10px;
      }
      .title, .content {
        white-space: pre;
        font-family: monospace;
        border: 2px solid #000;
        padding: 5px 10px;
        margin: 0 0 2px 0;
      }
    }

    .map-el {
      flex-grow: 1;
    }
  }
}
</style>
